export default __webpack_public_path__ + "static/media/easySeven.5217c6c9.png";